// These are simply enums, NOT interfaces for what the back-end actually returns.
export enum SpendLevelTypeFieldNames {
  ABSOLUTE_DOLLARS = 'absoluteDollars',
  ABSOLUTE_UNITS = 'absoluteUnits',
  DOLLAR_MARKET_SHARE = 'dollarMarketShare',
  UNIT_MARKET_SHARE = 'unitMarketShare'
}

/*
 * @important Ask back-end to provide SHORT_DISPLAY_NAME.
 * */
export enum AbsoluteDollars {
  DISPLAY_NAME = 'Spend Volume',
  FIELD_NAME = 'absoluteDollars',
  NAME = 'ABSOLUTE_DOLLARS', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Vol'
}

export enum AbsoluteUnits {
  DISPLAY_NAME = 'Units Volume',
  FIELD_NAME = 'absoluteUnits',
  NAME = 'ABSOLUTE_UNITS', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Unit Vol'
}

export enum DollarMarketShare {
  DISPLAY_NAME = 'Spend Market Share',
  FIELD_NAME = 'dollarMarketShare',
  NAME = 'DOLLAR_MARKET_SHARE', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Spend MS'
}

export enum UnitMarketShare {
  DISPLAY_NAME = 'Units Market Share',
  FIELD_NAME = 'unitMarketShare',
  NAME = 'UNIT_MARKET_SHARE', // for legacy support only - use FIELD_NAME instead
  SHORT_DISPLAY_NAME = 'Unit MS'
}

// Doubtful there would be more but you never know.
export enum Operators {
  AND = 'AND',
  AND_SYMBOL = '&'
}

// When the tier value is zero - we sometimes replace it with the label "Access"
export enum ValueLabels {
  ZERO = 'Access'
}

export enum SizeOfSpendTypeLabel {
  SHORT = 'SHORT_DISPLAY_NAME',
  LONG = 'DISPLAY_NAME'
}

/* Need better way to do this mapping and type. */
export const SpendLevelTypesMap = {
  absoluteDollars: AbsoluteDollars,
  absoluteUnits: AbsoluteUnits,
  dollarMarketShare: DollarMarketShare,
  unitMarketShare: UnitMarketShare
};
